import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import SearchBar from '../SearchBar';

const Header = () => {
  const { signOut, isAuthenticated } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  return (
    <header className="ph-header">
      <div className="ph-header-content">
        {/* Left side - Logo and Title */}
        <div className="ph-header-left">
          <div className="ph-logo">
            <img src="/PH-Icon-White-C.png" alt="ProductHub" className="w-12 h-12" />
          </div>
          <div className="ph-header-title">
            <h1>ProductHub</h1>
                            <span className="ph-header-subtitle">Alliance Portal</span>
          </div>
        </div>

        {/* Right side - Search and Sign In/Sign Out */}
        <div className="flex items-center gap-6 flex-shrink-0">
          {/* Search Bar - only show when authenticated */}
          {isAuthenticated && <SearchBar />}
          
          {/* Authentication */}
          {isAuthenticated ? (
            <button
              onClick={handleSignOut}
              className="ph-btn-signout"
            >
              <span>Sign Out</span>
            </button>
          ) : (
            <div className="text-gray-300">
              <span>Please sign in</span>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header; 